import React from "react";
import PropTypes from "prop-types";

import Text from "components/common/Text";
import Select from "components/common/Select";

import "./AccrualRules.scss";

const unitOptions = [
  { value: "day(s)", label: "day(s)" },
  { value: "month(s)", label: "month(s)" },
  { value: "year(s)", label: "year(s)" },
];

const timingOptions = [
  { value: "Start", label: "Start" },
  { value: "End", label: "End" },
];

function AccrualRules({ field, value: valueFromProps, name, setFormValues, isDisabled = false }) {
  const { labels } = field;
  const { amount: amountLabel = "Accrue", timing: timingLabel = "per month at" } = labels || {};

  const amount = valueFromProps?.amount || "";
  const unit = valueFromProps?.unit || "day(s)";
  const timing = valueFromProps?.timing || "End";

  const handleAmountChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        amount: e.target.value,
      },
    }));
  };

  const handleUnitChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        unit: newValue,
      },
    }));
  };

  const handleTimingChange = (newValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: {
        ...valueFromProps,
        timing: newValue,
      },
    }));
  };

  return (
    <div className="accrual-rules-field">
      <div className="accrual-inputs">
        <span className="para-body-m-medium text-headings-secondary">{amountLabel}</span>
        <div className="accrual-amount-input-container">
          <Text
            name="accrualAmount"
            type="text"
            value={amount}
            onChange={handleAmountChange}
            variant="outlined"
            size="small"
            hideHelperText
            disabled={isDisabled}
          />
        </div>
        <Select
          name="accrualUnit"
          className="accrual-rate-type-select"
          value={unit}
          onChange={handleUnitChange}
          options={unitOptions}
          variant="outlined"
          size="small"
          label=""
          disabled={isDisabled}
        />
        <span className="accrual-rate-label">{timingLabel}</span>
        <Select
          name="accrualTiming"
          className="accrual-rate-type-select"
          value={timing}
          onChange={handleTimingChange}
          options={timingOptions}
          variant="outlined"
          size="small"
          label=""
          disabled={isDisabled}
        />
      </div>
    </div>
  );
}

AccrualRules.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    labels: PropTypes.shape({
      amount: PropTypes.string,
      unit: PropTypes.string,
      timing: PropTypes.string,
    }),
  }).isRequired,
  value: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unit: PropTypes.string,
    timing: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  setFormValues: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

AccrualRules.defaultProps = {
  value: {},
  isDisabled: false,
};

export default AccrualRules;
